module.exports = __webpack_public_path__ + "static/media/resource-literature.8ee3d2fb.png";